import React, {useEffect} from "react";
//import $ from 'jquery';

const Loader = () =>{

    useEffect(() =>{

        /*setTimeout(function () {
			$('.preloader');
			setTimeout(function () {
				$(".preloader").fadeOut("slow");
			}, 500);
		}, 500);*/

    }, []);


    return(
        <>
            {/*-<div className="preloader">
                <span className="loader"></span>
            </div>*/}
            
            <div className="d-flex justify-content-center mb-4">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </>
    )
}

export default Loader;